<template>
  <div class="Product">
    <div class="ProductImge">
      <img src="" alt="">
    </div>
    <div class="introductionBox">
      <div class="introduction-mian">
        <div class="introduction_L">
          <div class="introductiontitle">产品介绍</div>
          <div class="introductionItem" :class="{current:current==index}" v-for="(item,index) in introduct" :key="index" @click="clickItem(index)">{{item.name}}</div>
        </div>
        <div class="introduction_r">
          <div class="introduction_name">服务器及存储相关概念</div>
          <div class="introduction_cont">
            <div class="introductiontext" v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content:`<p>服务器及存储是现代IT系统中重要的组成部分，为业务系统提供运算处理能力及数据存放等作用。
        从计算机系统建设的角度看，主要涵盖主机处理能力、网络通讯、外部存储、软件开发环境、应用软件等方面，这些方面的发展是相辅相成的，用户根据自己的业务特点，选择合适的配置即可完成选型。
        纵观当前主要的存储技术，主要包括三个比较流行的存储架构，即：以服务器为中心的DAS、以数据为中心的NAS、以网络为中心的SAN。</p>`,
        introduct:[{name:"虚拟化"},{name:"服务器存储"},{name:"交换路由"},{name:"软件管理"}],
        current:0
    }
  },
  methods:{
    clickItem(index){
      this.current = index
    }
  }
}
</script>

<style scoped lang="less">
.Product{
  .ProductImge{
    width: 100%;
    height: 480px;
    background: lightcoral;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .introductionBox{
    width: 100%;
    height: auto;
    margin-bottom: 148px;
    .introduction-mian{
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .introduction_L{
        width: 204px;
        height: auto;
        margin-right: 100px;
        .introductiontitle{
          width: 204px;
          height: 80px;
          background: #1373cf;
          font-size: 24px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
          line-height: 80px;
          border-bottom: 1px solid #fff;
        }
        .introductionItem{
          width: 204px;
          height: 80px;
          background: #1373cf;
          font-size: 18px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
          line-height: 80px;
          opacity: 0.8;
          border-bottom: 1px solid #fff;
          cursor: pointer;
        }
        .current{
          background: #1373CF;
          opacity: 0.5;
        }
      }
      .introduction_r{
        width: calc(1200px - 304px);
        .introduction_name{
          font-size: 30px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #333333;
          padding: 30px 0 60px 0;
        }
        .introduction_cont{
          .introductiontext{
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>
